import { Target } from '../@types';

const targetsForReports: Target[] = [
  { value: 'id', type: 'text', isAPI: false },
  { value: 'from', type: 'date', isAPI: false },
  { value: 'to', type: 'date', isAPI: false },
  { value: 'type', type: 'selection', isAPI: false },
  { value: 'status', type: 'selection', isAPI: false },
  { value: 'merchantId', type: 'text', isAPI: false },
  { value: 'reportClass', type: 'text', isAPI: false },
  { value: 'fileName', type: 'text', isAPI: false },
  { value: 'created', type: 'date', isAPI: false },
  { value: 'pendingSince', type: 'date', isAPI: false },
  { value: 'processingAt', type: 'date', isAPI: false },
  { value: 'generatedAt', type: 'date', isAPI: false },
  { value: 'uploadedAt', type: 'date', isAPI: false },
  { value: 'statusCode', type: 'number', isAPI: false },
];

export default targetsForReports;
